import LocaleStrings from "Languages";

export default function () {

  return [
    {
      title: LocaleStrings.analytics_submenu_title1,
      iconName: "dashboard",
      description: LocaleStrings.analytics_submenu_description1,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title3,
      iconName: "session",
      description: LocaleStrings.analytics_submenu_description3,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title4,
      iconName: "speaker",
      description: LocaleStrings.analytics_submenu_description4,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title5,
      iconName: "attendeesnetwork",
      description: LocaleStrings.analytics_submenu_description5,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title6,
      iconName: "attendeesmessaging",
      description: LocaleStrings.analytics_submenu_description6,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title7,
      iconName: "socialfeed",
      description: LocaleStrings.analytics_submenu_description7,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title8,
      iconName: "sponsorsinsight",
      description: LocaleStrings.analytics_submenu_description8,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title9,
      iconName: "exhibitorsinsight",
      description: LocaleStrings.analytics_submenu_description9,
      isenabled:true
    },
    {
      title: LocaleStrings.analytics_submenu_title10,
      iconName: "advertisementinsight",
      description: LocaleStrings.analytics_submenu_description10,
      isenabled:true
    },
    // {title:LocaleStrings.analytics_submenu_title2, iconName:'googleanalytic', description:LocaleStrings.analytics_submenu_description2},
  ];
}

